import { RouteObject } from 'react-router-dom'
import Home from './pages/home/Home'
import ArticleDetail from './pages/article/Detail'

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/article-detail/:type',
    element: <ArticleDetail />,
  },
  {
    path: '/article-detail/:type/:id',
    element: <ArticleDetail />,
  },
]

export default routes